<template>
    <div class="checkbox__wrapper">
        <input
                @change="$emit('update:modelValue', $event.target.checked); $emit('onChange', $event.target.value);"
                type="checkbox"
                :checked="modelValue"
                :id="fieldId"
                v-bind="$attrs"
        />
        <label :class="isFieldRequired ? 'req' : ''" v-if="label" :for="fieldId"><span v-html="label"></span></label>
    </div>
</template>

<script>
export default {
  name: "BaseOneChoiseCheckbox.vue",
  inheritAttrs: false,
  props: {
    label: {type: String, default: ''},
    fieldId: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    objectKey: {}
  },
  computed: {
    isFieldRequired() {
      if (this.objectKey) {
        return this.$parent.isFieldRequired(this.objectKey);
      }
      return false;
    },
    isFieldHasError() {
      return !!(this.isFieldRequired && this.isFormSubmitted && (this.currentValue === undefined || this.currentValue.length === 0));
    }
  }
};
</script>

<style scoped></style>